import { motion } from "framer-motion";

const DISC_META = {
  D: { label: "Dominance", color: "#EF4444", desc: "Direct · Results" },
  I: { label: "Influence", color: "#F59E0B", desc: "Social · Enthusiastic" },
  S: { label: "Steadiness", color: "#10B981", desc: "Supportive · Steady" },
  C: { label: "Conscientiousness", color: "#3B82F6", desc: "Precise · Analytical" },
};
const ORDER = ["D", "I", "S", "C"];

const DiscQuadrant = ({ disc }) => {
  const map = Object.fromEntries(disc.scores.map((s) => [s.trait, s.percent]));
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="disc-quadrant">
      {ORDER.map((t, i) => {
        const meta = DISC_META[t];
        const pct = map[t] || 0;
        const isPrimary = disc.primary === t;
        return (
          <motion.div
            key={t}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.08, duration: 0.35 }}
            className="relative rounded-2xl p-4 border overflow-hidden"
            style={{
              borderColor: meta.color + "40",
              background: meta.color + (isPrimary ? "1f" : "0d"),
            }}
            data-testid={`disc-cell-${t}`}
          >
            {isPrimary && (
              <span className="absolute top-2 right-2 text-[10px] font-heading font-bold uppercase tracking-wider px-2 py-0.5 rounded-full text-white"
                    style={{ background: meta.color }}>
                Primary
              </span>
            )}
            <div className="flex items-baseline gap-2">
              <span className="font-heading font-extrabold text-3xl" style={{ color: meta.color }}>{t}</span>
              <span className="font-heading font-bold text-xl text-slate-800">{pct}%</span>
            </div>
            <p className="font-heading font-bold text-sm text-slate-800 mt-1">{meta.label}</p>
            <p className="font-body text-xs text-slate-500">{meta.desc}</p>
            <div className="mt-3 h-1.5 rounded-full bg-slate-200 overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${pct}%`, background: meta.color }} />
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default DiscQuadrant;
